import { render } from "./UserUpdatePassword.vue?vue&type=template&id=6a7e3c2f"
import script from "./UserUpdatePassword.vue?vue&type=script&lang=js"
export * from "./UserUpdatePassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__